<mat-icon matTooltip="{{ 'GridTable.Filter.FilterNumber' | translate }}" [matMenuTriggerFor]="menu">filter_alt</mat-icon>
<mat-menu #menu="matMenu" class="p-3">
    <form [formGroup]="filterForm" (click)="$event.stopPropagation();">
        <div class="col">
            <mat-form-field>
              <mat-label>{{ 'GridTable.Filter.FilterType' | translate }}</mat-label>
                <mat-select [formControl]="filterTypeControl" [value]="filterTypeControl"
                    (selectionChange)="onFilterChange($event)" (click)="$event.stopPropagation();">
                    <mat-option *ngFor="let option of filterOptions" [value]="option.value"
                        (click)="$event.stopPropagation();">
                        {{ option.translationKey | translate }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </form>
    <ng-container *ngIf="this.currentFilter.value !== this.numberFilterBetween; else betweenTemplate">
        <form [formGroup]="singleNumberForm" (click)="$event.stopPropagation();">
            <div class="col">
                <mat-form-field>
                  <mat-label>{{'GridTable.Filter.Number' | translate }} </mat-label>
                    <input type="number" autocompleteOff matInput
                        [formControl]="numberSingleNumberControl" (click)="$event.stopPropagation();">
                </mat-form-field>
            </div>
        </form>
    </ng-container>
    <ng-template #betweenTemplate>
        <form [formGroup]="numberBetweenForm" (click)="$event.stopPropagation();">
            <div class="col">
                <mat-form-field>
                  <mat-label>{{'GridTable.Filter.From' | translate }} </mat-label>
                    <input type="number" autocompleteOff matInput
                        [formControl]="numberBetweenValueControl" (click)="$event.stopPropagation();">
                </mat-form-field>
            </div>
            <div class="col">
                <mat-form-field>
                  <mat-label>{{'GridTable.Filter.To' | translate }} </mat-label>
                    <input type="number" autocompleteOff matInput
                        [formControl]="numberBetweenValue2Control" (click)="$event.stopPropagation();">
                </mat-form-field>
            </div>
            <div class="mt-4">
            </div>
        </form>
    </ng-template>
    <div class="col" style="display: flex; justify-content: flex-end;">
        <mat-icon matTooltip="{{ 'GridTable.Filter.Cancel' | translate }}" style="cursor: pointer;" color="primary"
            (click)="onCancel()">
            clear
        </mat-icon>
        <mat-icon matTooltip="{{ 'GridTable.Filter.ApplyFilter' | translate }}" style="cursor: pointer;" color="primary"
            (click)="onSubmit($event)">
            check
        </mat-icon>
        <mat-icon matTooltip="{{ 'GridTable.Filter.Clear' | translate }}" style="cursor: pointer;" color="primary"
            *ngIf="this.currentValue | async" (click)="onClear()">
            delete
        </mat-icon>
    </div>
</mat-menu>
